import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./uomAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchAll = createAsyncThunk(
  "uom/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const uomSlice = createSlice({
  name: "uom",
  initialState,
  reducers: {
    resetData: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      });
  },
});

export const {resetData } = uomSlice.actions;

export const selectData = (state) => state.uom.value;
export const selectLoading = (state) => state.uom.loading;
export const selectError = (state) => state.uom.error;
export const selectPageNo = (state) => state.uom.pageNo;
export const selectPageSize = (state) => state.uom.pageSize;
export const selectTotalRecord = (state) => state.uom.totalRecord;

export default uomSlice.reducer;
